import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function OriginStorySection() {
  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full mb-6">
            <Icon name="BookOpenIcon" size={20} className="text-accent" variant="solid" />
            <span className="text-sm font-semibold text-accent">Our Founding Story</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            Born From Crisis, Built on Hope
          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            A message from Ekua Hudson, Founder and President
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative h-[400px] lg:h-[500px] rounded-2xl overflow-hidden shadow-brand-lg">
            <AppImage
              src="/assets/images/Screenshot_2026-02-03_at_12.55.54_PM-1770141359206.png"
              alt="Professional headshot of Ekua Hudson, Founder and President, wearing burgundy top"
              className="w-full h-full object-cover" />

          </div>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-brand-primary/5 to-brand-primary/10 rounded-xl p-8 border-l-4 border-brand-primary">
              <blockquote className="text-lg text-text-primary leading-relaxed italic">“The Food for Thought Foundation was born during the pandemic. We witnessed our communities struggling from food insecurity that was exacerbated by COVID, and realized that our food system was broken, so we got to work. We worked hard, raised money, and bought groceries for our neighbors. But we couldn't stop there. We realized we had to create solutions. This is the heart and soul of our organization today- creating solutions so that one day our communities won't be food insecure anymore.”

              </blockquote>
              <div className="mt-6 flex items-center gap-4">
                <div className="w-12 h-12 bg-brand-primary rounded-full flex items-center justify-center">
                  <Icon name="UserIcon" size={24} className="text-white" variant="solid" />
                </div>
                <div>
                  <p className="font-bold text-text-primary">Ekua Hudson</p>
                  <p className="text-sm text-text-secondary">Founder and President</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-brand-secondary/10 via-background to-brand-primary/5 rounded-2xl p-8 lg:p-12">
          <h3 className="text-2xl font-bold text-text-primary mb-8 text-center">Our Journey</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-brand-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="ExclamationTriangleIcon" size={40} className="text-white" variant="solid" />
              </div>
              <h4 className="text-xl font-bold text-text-primary mb-2">The Crisis</h4>
              <p className="text-text-secondary">Pandemic revealed broken food systems and deepened community struggles</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-accent rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="HeartIcon" size={40} className="text-white" variant="solid" />
              </div>
              <h4 className="text-xl font-bold text-text-primary mb-2">The Response</h4>
              <p className="text-text-secondary">Raised funds and bought groceries for neighbors in immediate need</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-success rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="LightBulbIcon" size={40} className="text-white" variant="solid" />
              </div>
              <h4 className="text-xl font-bold text-text-primary mb-2">The Solution</h4>
              <p className="text-text-secondary">Creating lasting systems to end food insecurity permanently</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

}